import * as appState from "../../state";

export default ({
  state,
  actions,
  history,
  routeName,
  Step,
  previousStepName,
  nextStepName,
}) => {
  actions.createAzureClient({ history });

  if (!Step) return null;

  return (
    <Step
      {...{
        state,
        actions,
        history,
        routeName,
        previousStepName,
        nextStepName,
      }}
    />
  );
};
